import { render, staticRenderFns } from "./TeachBrandsEditLayer.vue?vue&type=template&id=5689e268&scoped=true&"
import script from "./TeachBrandsEditLayer.vue?vue&type=script&lang=js&"
export * from "./TeachBrandsEditLayer.vue?vue&type=script&lang=js&"
import style0 from "./TeachBrandsEditLayer.vue?vue&type=style&index=0&id=5689e268&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5689e268",
  null
  
)

export default component.exports